export enum LevelRegleEnum {
  Technique,
  Metier,
  Transmettre
}

export type LevelRegle = keyof typeof LevelRegleEnum
